export const INDICATOR_SIZE = '20px';
